import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setTicket = createAction<{
  field: FlattenKeys<TicketState>;
  value: any;
}>(actionTypes.SET_TICKET);

export const resetTicket = createAction<void>(actionTypes.RESET_TICKET);

const ticketActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setTicket: <T extends FlattenKeys<TicketState>>(
        field: T,
        value: DeepType<TicketState, T>,
      ) => dispatch<void>(setTicket({ field, value })),
      resetTicket: () => dispatch<void>(resetTicket()),
    },
  );

export default ticketActions;
